import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  private $applicationStatus: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor() { }

  /**
   * @description - Get the updated application status from the observable
   * @returns - Observable<any>
   */
  getApplicationStatus(): Observable<any> {
    return this.$applicationStatus.asObservable();
  }

  /**
   * @description - Notify the application status to all the subscribers
   * @param status - Status to be updated
   * @example updateApplicationStatus('update')
   */
  updateApplicationStatus(status: any): void {
    this.$applicationStatus.next(status);
  }

  /**
   * @description - Reset the application status to initial state
   */
  resetApplicationStatus(): void {
    this.$applicationStatus.next(null);
  }
}
